import { ConversationMessage } from '../interfaces/Derivation';

export interface ChatMessage {
  role: 'user' | 'assistant' | 'agent';
  content: string;
  dt?: string;
}

export const parseChatHistoryToMessages = (
  chatData?: string
): ChatMessage[] => {
  if (!chatData || typeof chatData !== 'string') return [];

  const messages: ChatMessage[] = [];
  try {
    const parsedData: any = JSON.parse(chatData);

    if (
      parsedData &&
      typeof parsedData === 'object' &&
      parsedData.historial_chat
    ) {
      const chatLines: string[] = String(parsedData.historial_chat)
        .split('\n')
        .filter((line: string) => line && line.trim() !== '');

      chatLines.forEach((line: string) => {
        const trimmedLine: string = line.trim();

        if (
          trimmedLine.startsWith('- User:') ||
          trimmedLine.startsWith('  - User:')
        ) {
          const content: string = trimmedLine
            .replace(/^(\s*- User:\s*\\?"?)/, '')
            .replace(/\\?"?$/, '');
          messages.push({
            role: 'user',
            content: content.replace(/^"|"$/g, ''),
          });
        } else if (
          trimmedLine.startsWith('- Assistant:') ||
          trimmedLine.startsWith('  - Assistant:')
        ) {
          const content: string = trimmedLine.replace(
            /^(\s*- Assistant:\s*)/,
            ''
          );
          messages.push({
            role: 'assistant',
            content: content.replace(/^"|"$/g, ''),
          });
        }
      });
    }
  } catch (error) {
    console.error('Error al parsear el chat desde description:', error);
  }
  return messages;
};

export const mapConversationToMessages = (
  conversation: ConversationMessage[]
): ChatMessage[] => {
  if (!Array.isArray(conversation)) return [];

  return conversation
    .filter(
      (msg) => msg && msg.actor && typeof msg.actor === 'string' && msg.message
    )
    .map((msg) => ({
      role: (msg.actor.toLowerCase() === 'agent'
        ? 'agent'
        : msg.actor.toLowerCase() === 'user'
          ? 'user'
          : 'assistant') as 'user' | 'assistant' | 'agent',
      content: String(msg.message || '').replace(/^"|"$/g, ''),
      dt: msg.dt,
    }));
};
